module.exports = __webpack_public_path__ + "static/media/Каюмов Ш., Бекчанов Ш., Зиядуллаева Ш..b417b5d7.pdf";